<template>
  <div>
    <!-- table responsive -->
    <div class="d-flex mt-3 mb-3 d-flex flex-wrap">
      <div class="me-2 ta-right w-250px">
        <b-form-group description="Filter by SKU">
          <multiselect v-model="sku" :options="skuOptions" track-by="value" label="text"
            select-label="Click to select" deselect-label="Click to remove" placeholder="Select SKU"
            :allow-empty="false" :preselect-first="true"></multiselect>
        </b-form-group>
      </div>
      <div class="me-2 ta-right w-350px">
        <b-form-group description="Filter by Rebate Status">
          <multiselect v-model="status" :options="statusOptions" track-by="value" label="text"
            select-label="Click to select" deselect-label="Click to remove" placeholder="Select Status"
            :allow-empty="false" :preselect-first="true"></multiselect>
        </b-form-group>
      </div>
      <div class="me-3 ta-right">
        <b-form-group description="Filter by Transaction Date">
          <b-input-group>
            <b-input-group-append class="rounded-0 rounded-start input-group-icon" variant="white">
              <i class="bx bx-calendar"></i>
            </b-input-group-append>
            <flat-pickr 
              v-model="lookupParams.dateRange" 
              :config="rangeOptions"
              placeholder="Select a date range" 
              class="form-control ps-2 rounded-end border-start-0">
            </flat-pickr>
          </b-input-group>
        </b-form-group>
      </div>
      <div class="">
        <b-form-group label="">
          <b-button variant="primary" type="button" @click="onSearch" class="px-2 btn btn-primary h-fit me-2">
            <i class='bx bx-search bx-fw'></i> Search
          </b-button>
        </b-form-group>
      </div>
    </div>
    <div class="table-responsive">
      <div class="table align-middle table-nowrap">
        <b-table
          :items="campaigns"
          :fields="fieldsCampaign"
          :no-local-sorting="true" 
          @sort-changed="handleSort"
        >
          <template #cell(action)="data">
            <div
              class="d-flex"
              v-if="data.item.promoStatus == 'draft'"
            >
              <div class="btn-group me-2 mb-2 mb-sm-0">
                <!-- showUpdateModal -->
                <router-link :to="{ name: 'E-Load Campaign', params: { campaignId: data.item.campaignId, mode: 'edit' }}">
                  <button
                    v-b-tooltip.hover 
                    title="Edit draft" 
                    type="button" 
                    class="btn btn-sm btn-primary">
                    <i class="bx bx-edit bx-xs bx-fw"></i>
                  </button>
                </router-link>
              </div>
              <b-button
                  v-b-tooltip.hover 
                  title="Delete draft" 
                  id="show-btn"
                  class="btn btn-sm btn-danger"
                  @click="remove(data.item.campaignId)"
                  ><i class="bx bx-trash bx-xs bx-fw"></i
                ></b-button>
            </div>
            <div
              class="d-flex"
              v-if="data.item.promoStatus == 'denied' || data.item.promoStatus == 'ended' || data.item.promoStatus == 'expired' || data.item.promoStatus == 'sold_out' || data.item.promoStatus == 'voided'" 
            >
              <div class="btn-group me-2 mb-2 mb-sm-0">
                <!-- showUpdateModal -->
                <router-link :to="{ name: 'E-Load Campaign', params: { campaignId: data.item.campaignId, mode: 'duplicate' }}">
                  <button
                    v-b-tooltip.hover 
                    title="Copy campaign"
                    type="button" 
                    class="btn btn-sm btn-secondary">
                    <i class="bx bx-copy bx-xs bx-fw"></i>
                  </button>
                </router-link>
              </div>
            </div>
            <div
              class="d-flex"
              v-if="data.item.promoStatus == 'on_going' || data.item.promoStatus == 'on_hold_on_going'" 
            >
              <b-button
                  v-b-tooltip.hover 
                  title="End campaign"
                  class="btn btn-sm btn-danger"
                  @click="endCampaign(data.item)"
                  ><i class="bx bx-calendar-x bx-xs bx-fw"></i
              ></b-button>
            </div>

             <div
              class="d-flex"
              v-if="data.item.promoStatus == 'not_started' || data.item.promoStatus == 'on_hold_not_started'" 
            >
              <b-button
                  v-b-tooltip.hover 
                  title="Void campaign"
                  class="btn btn-sm btn-danger"
                  @click="voidCampaign(data.item)"
                  ><i class="bx bx-x-circle bx-xs bx-fw"></i
              ></b-button>
            </div>

          </template>
          <template #cell(promoStartDate)="data">
            <span v-if="checkDate(data.item.promoStartDate)">
              {{data.item.promoStartDate | standardDate}}
            </span>
            <span v-else>
               -
            </span>
          </template>
          <!-- Dates template -->
          <template #cell(isActive)="data">
            <div
              class="d-flex align-items-center" 
              v-if="data.item.promoStatus == 'not_started' || data.item.promoStatus == 'on_going' || data.item.promoStatus == 'on_hold_on_going' || data.item.promoStatus == 'on_hold_not_started'">
              <toggle-button
                class="m-0 me-2"
                v-model="data.item.isActive"
                :disabled="checkEloadSkuStatus(data.item.skuIds)"
                @change="changeStatus(data.item)"
                color="#e73092"
                :sync="true"
              />
              <span class="status">{{data.item.isActive ? 'Enable' : 'Disable'}}</span>
            </div>
          </template>
          <template #cell(promoEndDate)="data">
            <span v-if="checkDate(data.item.promoEndDate)">
              {{data.item.promoEndDate | standardDate}}
            </span>
            <span v-else>
               -
            </span>
          </template>
          <template #cell(lm_approved_at)="data">
            <span v-if="checkDate(data.item.lm_approved_at)">
              {{data.item.lm_approved_at | standardDate}}
            </span>
            <span v-else>
               -
            </span>
          </template>
          <template #cell(fm_approved_at)="data">
            <span v-if="checkDate(data.item.fm_approved_at)">
              {{data.item.fm_approved_at | standardDate}}
            </span>
            <span v-else>
               -
            </span>
          </template>
          <template #cell(terminatedAt)="data">
            <span v-if="checkDate(data.item.terminatedAt)">
              {{data.item.terminatedAt | standardDate}}
            </span>
            <span v-else>
               -
            </span>
          </template>
          <template #cell(purchaseCount)="data">
            {{data.item.purchaseCount}}
            <b-icon
              v-if="data.item.promoStatus == 'on_going' || data.item.promoStatus == 'ended'"
              v-b-tooltip.hover 
              title="Export purchase report"
              @click="exportCampaignData(data.item.campaignId)" 
              class="ms-3 campaign-purchase-export" 
              icon="box-arrow-in-up-right">
            </b-icon>
          </template>
          <template #cell(createdAt)="data">
            {{data.item.createdAt | standardDate}}
          </template>
          <!-- End date template -->
          <template #cell(promoStock)="data">
            {{data.item.promoDistribution == 's' ? data.item.promoStock : '-'}} 
          </template>
          <template #cell(promoFrequency)="data">
            {{data.item.promoDistribution == 'f' ? data.item.promoFrequency : '-'}}
          </template>
          <template #cell(eloadDefaultRebate)="data">
            <div :key="index" v-for="(item, index) in data.item.skuIds">
              <span class="badge bg-light text-dark fs-6" style="margin-bottom: 3px;">
                {{ item.eloadDefaultRebate + '%' }}
              </span>
            </div>
          </template>
          <template #cell(promoRebate)="data">
            {{data.item.promoRebate}}%
          </template>
          <template #cell(statusText)="data">
            <span :class="statusColor(data.item.promoStatus)">
              {{data.item.statusText}}
            </span>
          </template>
          <template #cell(mdList)="data">
            <div v-if="!isEmpty(data.item.mdIds)">
              <div :key="index" v-for="(id, index) in data.item.mdIds">
                <span class="badge badge-outline-primary me-1 badge-secondary">
                  {{mopData(id, data.item.mdRebate)}}
                </span>
              </div>
            </div>
            <div v-else>
              -
            </div>
          </template>
          <template #cell(eloadSkuName)="data">
            <div :key="index" v-for="(item, index) in data.item.skuIds">
              <span class="badge bg-light text-dark fs-6" style="margin-bottom: 3px;">
                {{ item.eloadSkuName }}
              </span>
            </div>
          </template>
        </b-table>
      </div>
    </div>
    <!-- end table responsive -->
    <div class="row g-0 text-center" v-if="loadCampaignTotalRows == 0">
      <span>No data to display.</span>
    </div>
    <!-- pagination -->
    <div
      class="row g-0 text-center text-sm-start"
      v-if="loadCampaignTotalRows != 0 && loadCampaignTotalRows > 10"
    >
      <!-- end col -->
      <div class="col-sm-12">
        <div class="row">
          <div class="col">
            <div class="form-group row pull-left">
              <label for="staticEmail" class="col-sm-6 col-form-label"
                >Display:</label
              >
              <div class="col-sm-6">
                <b-form-group label-for="display-record">
                  <b-form-select
                    class="form-select shadow-none w-fit"
                    id="display-record"
                    v-model="pagination.rows"
                    :options="pageOptions"
                    @change="getCampaignsList()"
                  ></b-form-select>
                </b-form-group>
              </div>
            </div>
            <div class="dataTables_paginate paging_simple_numbers float-end">
              <b-pagination
                class="pagination-rounded"
                v-model="pagination.page"
                @input="getCampaignsList()"
                :total-rows="loadCampaignTotalRows"
                :per-page="pagination.rows"
              ></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end pagination -->
  </div>
</template>

<script>
import { digitalLoadMethods, digitalLoadComputed, layoutMethods, exportMethods, erpUsersMethods, erpUsersComputed ,mopComputed,mopMethods} from '@/state/helpers';
import moment from 'moment';
import { ToggleButton } from 'vue-js-toggle-button'
import Swal from 'sweetalert2';
import _ from "lodash";
import Multiselect from "vue-multiselect";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { getModuleAccess } from '@/router/helper.js'

export default {
  data() {
    return {
      remarks: [
        "Change in Business strategy",
        "Due to Issues / Bugs in the App",
        "Identified Fraud for further investigation",
        "Overlapped with another campaign"
      ],
      campaigns: [],
      totalRows: 1,
      currentPage: 1,
      pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
      statusOptions: [
        {value: null, text: 'All'},
        {value: 'not_started', text: 'Not started'},
        {value: 'on_going', text: 'Ongoing'},
        {value: 'on_hold', text: 'On hold'},
        {value: 'awaiting_lm', text: 'Waiting Line Manager Approval'},
        {value: 'awaiting_fm', text: 'Waiting Finance Approval'},
        {value: 'draft', text: 'Draft'},
        {value: 'ended', text: 'Ended'},
        {value: 'denied', text: 'Denied'},
        {value: 'expired', text: 'Expired'},
        {value: 'sold_out', text: 'Sold Out'},
        {value: 'voided', text: 'Voided'},
      ],
      fieldsCampaign: [
        {
          key: 'action',
          sortable: false,
        },
        {
          key: 'eloadSkuName',
          label: 'SKU Name',
          sortable: false,
        },
        {
          key: 'isActive',
          label: 'SKU Status',
          sortable: true,
        },
        {
          key: 'eloadDefaultRebate',
          label: 'Default Rebate',
          sortable: true,
        },
        {
          key: 'promoRebate',
          label: 'Promo Rebate',
          sortable: true,
        },
        {
          key: 'promoName',
          label: 'Promo Name',
          sortable: true,
        },
        {
          key: 'statusText',
          label: 'Rebate Status',
          sortable: true,
        },
        {
          key: 'requirementText',
          label: 'Users who can avail',
          sortable: false,
        },
        {
          key: 'mdList',
          label: 'Mode of Payments',
          sortable: false,
          // thClass: "text-end",
        },
        {
          key: 'qualifierText',
          label: 'Qualifier',
          sortable: false,
        },
        {
          key: 'promoStock',
          label: 'Promo Stocks Allocated',
          sortable: true,
        },
        {
          key: 'purchaseCount',
          label: 'Purchase Count',
          sortable: false,
        },
        {
          key: 'pendingCount',
          label: 'Pending Purchase Count',
          sortable: false,
        },
        {
          key: 'promoFrequency',
          label: 'Availment frequency per users',
          sortable: true,
        },
        {
          key: 'promoStartDate',
          label: 'Promo Start Time',
          sortable: true,
        },
        {
          key: 'promoEndDate',
          label: 'Promo End Time',
          sortable: true,
        },
        {
          key: 'createdAt',
          label: 'Date Created',
          sortable: true,
        },
        {
          key: 'createdBy',
          label: 'Created By',
          sortable: true,
        },
        {
          key: 'lineManagerApprover',
          label: 'Approved By Line Manager',
          sortable: false,
        },
        {
          key: 'lm_approved_at',
          label: 'Line Manager Approved At',
          sortable: false,
        },
        {
          key: 'financeManagerApprover',
          label: 'Approved By Finance Manager',
          sortable: false,
        },
        {
          key: 'fm_approved_at',
          label: 'Finance Manager Approved At',
          sortable: false,
        },
        {
          key: 'terminatedAt',
          label: 'Date and Time Voided',
          sortable: false,
        },
        {
          key: 'remarks',
          label: 'Remarks',
          sortable: false,
        }
      ],
      pagination: {
        rows: 10,
        page: 1,
        sort: 'id',
        orderDesc: true
      },
      lookupParams: {
        sku: '',
        status: '',
        dateRange: ''
      },
      rangeOptions: {
        mode: "range",
        maxDate: "today"
      },
      eloadTopupsModule: {
          access: {
            create: true,
            update: true,
            delete: true
          }
        }
    }
  },
  methods: {
    ...erpUsersMethods,
    ...digitalLoadMethods,
    ...layoutMethods,
    ...exportMethods,
    ...mopMethods,
    voidCampaign(campaign){
      this.fetchCampaignLineManagers(campaign.campaignId).then(() => {
        Swal.fire({
          title: "Void campaign?",
          html: this.endHtml,
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "No",
          confirmButtonColor: "#c4297c",
          cancelButtonColor: "#804997",
          confirmButtonText: "Yes",
        }).then((result) => {
          if(result.value){
            this.voidEloadCampaign({ 
                campaignId: campaign.campaignId,
                remarks: document.getElementById('campaign-remarks').value,
                alignedWith: parseInt(document.getElementById('campaign-aligned-lm').value)
              })
              .then(() => {
                campaign.promoStatus = 'voided';
                campaign.statusText = 'VOIDED';
                Swal.fire("Success!", `Campaign has been voided successfully.`, "success");
              })
              .catch((error) => {
                Swal.fire(
                  "Update Failed!",
                  `Campaign was not voided.<br />${error}`,
                  "error"
                );
              });
          }        
        });
      });
      
    },
    endCampaign(campaign){
      this.fetchCampaignLineManagers(campaign.campaignId).then(() => {
        Swal.fire({
          title: "End campaign?",
          html: this.endHtml,
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "No",
          confirmButtonColor: "#c4297c",
          cancelButtonColor: "#804997",
          confirmButtonText: "Yes",
        }).then((result) => {
          if(result.value){
            this.endEloadCampaign({ 
                campaignId: campaign.campaignId,
                remarks: document.getElementById('campaign-remarks').value,
                alignedWith: parseInt(document.getElementById('campaign-aligned-lm').value)
              })
              .then(() => {
                campaign.promoStatus = 'ended';
                campaign.statusText = 'Ended';
                Swal.fire("Success!", `Campaign has been ended successfully.`, "success");
              })
              .catch((error) => {
                Swal.fire(
                  "Update Failed!",
                  `Campaign was not ended.<br />${error}`,
                  "error"
                );
              });
          }        
        });
      });
    },
    exportCampaignData(campaignId){
      Swal.fire({
        title: "Export campaign data?",
        text: `This will send a spreadhsheet of the purchase details of this campaign to your email.`,
        icon: "question",
        showCancelButton: true,
        cancelButtonText: "No",
        confirmButtonColor: "#c4297c",
        cancelButtonColor: "#804997",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          let params = {
            ext: 'xlsx',
            campaignId: campaignId,
            module: 'eload_campaigns_purchase',
            email: JSON.parse(localStorage.getItem('userData')).email
          };
          
          this.exportReport(params)
            .then(() => Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success"))
            .catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));
        }
      });
    },
    statusColor(status){
      if(status == 'on_going'){
        return 'status status-green';
      } else if(status == 'not_started' || status == 'on_hold_not_started'){
        return 'status status-black';
      } else {
        return 'status status-grey';
      }
    },
    changeStatus(campaign){
      this.updateEloadCampaignStatus({
        campaignId: campaign.campaignId,
        isActive: campaign.isActive
      })
      .then(() => {
        Swal.fire(
          "Update Success!",
          `Campaign was ${campaign.isActive ? 'activated' : 'deactivated'}.`,
          "success"
        ).then(() => {
          this.getCampaignsList();
        });
      })
      .catch((error) => {
        campaign.isActive = false;
        Swal.fire(
          "Update Failed!",
          `Campaign was not activated.<br />${error}`,
          "error"
        );
      });
    },
    getCampaignsList(){
      this.getEloadCampaignList(this.pagination).then(() => {
        this.campaigns = _.cloneDeep(this.loadCampaignList);
      });
    },
    remove(campaignId){
      if (!this.eloadTopupsModule.access.delete) {
          Swal.fire(
            "Access Restricted",
            "You are not allowed to delete a Campaign.",
            "warning"
          );
        } else {
          Swal.fire({
            title: "Are you sure?",
            text: `This will permanently delete this campaign?`,
            icon: "question",
            showCancelButton: true,
            cancelButtonText: "No",
            confirmButtonColor: "#c4297c",
            cancelButtonColor: "#804997",
            confirmButtonText: "Yes",
          }).then((result) => {
            if (result.value) {
              this.deleteEloadCampaign(campaignId)
                .then(() => {
                  Swal.fire({
                    title: "Successfully Deleted!",
                    text: `Campaign has been deleted.`,
                    icon: "success",
                    showCancelButton: false,
                    confirmButtonColor: "#c4297c",
                    confirmButtonText: "OK",
                    showLoaderOnConfirm: true,
                  }).then(() => {
                    this.getCampaignsList();
                  });
                })
                .catch((error) => {
                  Swal.fire(
                    "Delete Failed!",
                    `Campaign was not deleted.<br />${error}`,
                    "error"
                  );
                });
            }
          });
        }
    },
    handleSort(ctx) {
      console.log(ctx);
      this.pagination.sort = ctx.sortBy;
      this.pagination.orderDesc = ctx.sortDesc;
      this.getCampaignsList();
    },
    onSearch(){
      this.pagination = Object.assign(this.pagination, this.lookupParams);
      this.getCampaignsList();
    },
    onRefresh(){
      this.getCampaignsList();
    },
    onExport(){
        let params = Object.assign(
        _.cloneDeep(this.pagination), 
        _.cloneDeep(this.lookupParams), 
        {
          ext: 'xlsx',
          module: 'eload_campaigns',
          email: JSON.parse(localStorage.getItem('userData')).email
        });

        delete params.page;
        delete params.rows;

        console.log(this.pagination);
        
        this.exportReport(params)
          .then(() => Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success"))
          .catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));
      }
    ,checkDate(date){
      var r = (new Date(date) !== "Invalid Date") && !isNaN(new Date(date));
      r = date == null ? false:r
      return r;
    },
    retrieveMopOpts(){
      this.getMopModuleOpt({module:"eload_wallet",isAll:true});
    },
    mopData(id, rebate=[]){
      try {
        var rp = this.isEmpty(rebate)? null : rebate.filter((r)=>{
          return r.id == id
        }).map((r)=>{
          return r.rp
        });
        var text = this.mopOptions.filter(m => {
          return m.methodId == parseInt(id);
        }).map((m)=>{
          return `${m.displayName} ${this.isEmpty(rp) ? "" : `(rebate: ${rp}%)` }`
        });
        return text.length > 0 ? text[0]:text
      } catch (error) {
        return text
      }
    },
    isEmpty(value) {
      return value == null ||
          value === "" ||
          (Object.prototype.hasOwnProperty.call(value, 'length') && value.length === 0) ||
          (value.constructor === Object && Object.keys(value).length === 0);
    },
    checkEloadSkuStatus(skus) {
      let isDisabled = false;
      for (let sku of skus) {
        isDisabled = sku.eloadSkuStatus != 1 ? true : false
      }
      return isDisabled;
    }

  },
  computed: {
    ...erpUsersComputed,
    ...digitalLoadComputed,
    ...mopComputed,
    endHtml: {
      get(){
        var titleDiv = '<div class="mb-4">This is an irreversible action and will terminate this campaign.</div>';

        var selectOne = '<select id="campaign-remarks" class="form-control" >'
        selectOne += '<option value="" disabled selected>Select remarks</option>'
        this.remarks.forEach(r => {
          selectOne += `<option value="${r}">${r}</option>`
        });
        selectOne += "</select>";
        var divOne = '<div class="mb-4">'+selectOne+'</div>';


        var selectTwo = '<select id="campaign-aligned-lm" class="form-control" >'
        selectTwo += '<option value="" disabled selected>Select aligned line manager</option>'
        this.campaignManagerList.forEach(m => {
          selectTwo += `<option value="${m.id}">${m.name}</option>`
        });
        selectTwo += "</select>";
        var divTwo = "<div>"+selectTwo+'</div>';

        var html = `<div>${titleDiv}${divOne}${divTwo}</div>`
        return html;
      }
    },
    sku: {
      get() {
        var sku = null;
        this.skuOptions.forEach((s) => {
          if (s.value == this.lookupParams.sku) {
            sku = s;
          }
        });
        return sku;
      },
      set(sku) {
        if (sku) {
          this.lookupParams.sku = sku.value;
        } else {
          this.lookupParams.sku = null;
        }
      }
    },
    status: {
      get() {
        var status = null;
        this.statusOptions.forEach((s) => {
          if (s.value == this.lookupParams.status) {
            status = s;
          }
        });
        return status;
      },
      set(status) {
        if (status) {
          this.lookupParams.status = status.value;
        } else {
          this.lookupParams.status = null;
        }
      }
    },
    skuOptions: {
      get(){
        var options = [{ text: 'All', value: null}];
        this.loadTopupsList.forEach(lp => {
          options.push({
            text: lp.topupName,
            value: lp.topupId
          });
        });
        return options;
      }
    }
  },
  components: {
    ToggleButton,
    Multiselect,
    flatPickr
  },
  async mounted(){
    this.getCampaignsList();
    this.retrieveMopOpts();
    // get the module access for checking if user has create, read, update, and/or delete access
    await getModuleAccess('Products', 'eLoad', 'eLoad Topups')
      .then((access) => this.eloadTopupsModule.access = access);
  },
  filters: {
    standardDate: function(value){
      return moment(value).format('MMM DD, YYYY, h:mm A')
    }
  }
};
</script>

<style>
.status {
  font-weight: bold;
}

.status-green {
  color: #139613;
}

.status-grey {
  color: #AAAAAA;
}

.status-black {
  color: #000;
}

.w-200px {
  width: 200px;
}

.w-250px {
  width: 250px;
}

.w-350px {
  width: 350px;
}

.campaign-purchase-export {
  cursor: pointer;
}
</style>